import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const MiniResourceCard = makeShortcode("MiniResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <MiniResourceCard slots="image,heading,text,link" repeat="3" theme="lightest" inRow="3" textColor="#424242" className="marketPlace inColumn" mdxType="MiniResourceCard" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/static/ab4c9edded535b0acaad44e78a32e051/e72e6/Artboard_Mockups.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/static/ab4c9edded535b0acaad44e78a32e051/de2c4/Artboard_Mockups.png 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/static/ab4c9edded535b0acaad44e78a32e051/de2c4/Artboard_Mockups.png",
            "alt": "Artboard Mockups",
            "title": "Artboard Mockups",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "artboard-mockups"
    }}>{`Artboard Mockups`}</h2>
    <p>{`Access 10,000+ high quality mockups right inside Adobe Express.`}</p>
    <p><a parentName="p" {...{
        "href": "https://express.adobe.com/new?category=addOns&launchAddOnId=wl102g614"
      }}>{`https://express.adobe.com/new?category=addOns&launchAddOnId=wl102g614`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/static/a3bf5b08f77722b06e6d9e1b8d6cc03f/e72e6/KirkeyAIAnimate.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/static/a3bf5b08f77722b06e6d9e1b8d6cc03f/de2c4/KirkeyAIAnimate.png 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/static/a3bf5b08f77722b06e6d9e1b8d6cc03f/de2c4/KirkeyAIAnimate.png",
            "alt": "Krikey AI Animate",
            "title": "Krikey AI Animate",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "krikey-ai-animate"
    }}>{`Krikey AI Animate`}</h2>
    <p>{`Generate 3D animated talking avatars.`}</p>
    <p><a parentName="p" {...{
        "href": "https://express.adobe.com/new?category=addOns&launchAddOnId=w0n746333"
      }}>{`https://express.adobe.com/new?category=addOns&launchAddOnId=w0n746333`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "144px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/static/f3d898eb256df092738f0a5fdbe80370/e72e6/Speedpaint.webp 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/express/static/f3d898eb256df092738f0a5fdbe80370/de2c4/Speedpaint.png 144w"],
            "sizes": "(max-width: 144px) 100vw, 144px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/express/static/f3d898eb256df092738f0a5fdbe80370/de2c4/Speedpaint.png",
            "alt": "Speedpaint",
            "title": "Speedpaint",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h2 {...{
      "id": "speedpaint"
    }}>{`Speedpaint`}</h2>
    <p>{`Convert any image to a speed drawing video.`}</p>
    <p><a parentName="p" {...{
        "href": "https://express.adobe.com/new?category=addOns&addOnId=w466h1l71"
      }}>{`https://express.adobe.com/new?category=addOns&addOnId=w466h1l71`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      